import { IBuyCustomPackageHandlerParams } from './buyCustomPackage';
import { IBuyPackageHandlerParams } from './buyPackage';

export type TBillingUserType = 'legal' | 'natural';

export interface IPayPackageMicrofrontendAPI {
  buyPackage(parameters: IBuyPackageHandlerParams): Promise<void>;
  buyCustomPackage(parameters: IBuyCustomPackageHandlerParams): Promise<void>;
}

/** Типы пакетов для внутреннего использования на фронте */
export enum EInternalPackageType {
  /** Пакет (старый раздел, вкладка "Купить пакет") */
  LegacyPackage = 'legacy_package',
  /** Подписка (новый раздел, вкладка "Купить пакет") */
  Subscription = 'subscription',
  /** Персональный пакет (новый раздел, вкладка "Персональные предложения") */
  PersonalPackage = 'personal_package',
  /** Персональная подписка на слоты (новый раздел, вкладка "Персональные предложения") */
  PersonalSubscription = 'personal_subscription',
  /** Персональная подписка на публикации (новый раздел, вкладка "Персональные предложения") */
  PersonalSubscriptionPublication = 'personal_subscription_publication',
  /** Смарт-пакет (новый раздел, вкладка "Персональные предложения") */
  SmartPackage = 'smart_package',
  /** Конструктор (новый и старый разделы, вкладка "Собрать свой пакет") */
  CustomPackage = 'custom_package',
}

export enum EPackageType {
  // обычный пакет
  Common = 'commonOffer',
  // акция по промокоду
  Special = 'specialOffer',
  // персональное предложение
  Personal = 'personalOffer',
  /** Общее предложение - подписки на публикации **/
  CommonSubscription = 'commonSubscription',
  /** Смарт-пакет **/
  SmartPackage = 'smartPackage',
  /** Пакет "Всё включено" */
  AllIn = 'allIn',
  /** Подписка */
  Subscription = 'subscription',
}

export enum ESubscriptionLevel {
  /** Бронзовый **/
  Bronze = 'bronze',
  /** Серебряный **/
  Silver = 'silver',
  /** Золотой **/
  Gold = 'gold',
  /** Платиновый **/
  Platinum = 'platinum',
}
